import { Asset } from 'app-lib/assetUtils'
import { DEX } from 'app-lib/dexSelector/types'
import { ProviderType } from 'bzx-common/src/domain/ProviderTypeDictionary'
import { BigNumber } from '@0x/utils'
import { getBaseQuote, IChainConfig, udfFeeds } from './chainCommon'

const assets = [Asset.BNB, Asset.ETH, Asset.BUSD, Asset.BTCB, Asset.USDT, Asset.LINK]

const tradePairs: [Asset, Asset][] = [
  [Asset.BNB, Asset.BUSD],
  [Asset.BNB, Asset.USDT],
  [Asset.BTCB, Asset.BUSD],
  [Asset.BTCB, Asset.USDT],
  [Asset.BUSD, Asset.USDT],
  [Asset.ETH, Asset.BUSD],
  [Asset.ETH, Asset.USDT],
  [Asset.LINK, Asset.BUSD],
  [Asset.LINK, Asset.USDT],
]

// add iTokens as collateral
const collateralAssets: Asset[] = assets.concat(assets.map((asset) => ('I' + asset) as Asset))

const config: IChainConfig = {
  chainDetails: {
    chainId: 56,
    blocksPerYear: (60 * 60 * 24 * 365) / 3,
    blockExplorer: 'https://bscscan.com',
    chainName: 'BNB Smart Chain',
    shortName: 'BSC',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    rpcUrls: [
      'https://bsc-dataseed.binance.org/',
      'https://bsc-dataseed1.defibit.io/',
      'https://bsc-dataseed1.ninicoin.io/',
      'https://bsc-dataseed3.binance.org/',
    ],
  },
  borrowing: { assets, collateralAssets },
  comingSoon: {
    tokens: {},
  },
  contracts: {
    bzx: '0xD154eE4982b83a87b0649E5a7DDA1514812aFE1f',
    helperProxy: '0x81B91c9a68b94F88f3DFC4F375f101223dDd5007',
    priceFeed: '0x7038600CE4E4059436E32DA4a2fc6476fCfD7A2A',
    sweepFees: '0xC9726942C732fa048dC56f0DeBea7fB2c596bA8C',
    tokenRegistry: '0x1BE70f29D30bB1D325E5D76Ee73109de3e50A57d',
  },
  dexes: [DEX.SUSHI],
  dexesDetails: { [DEX.SUSHI]: { id: 1, address: '0x3D87106A93F56ceE890769A808Af62Abc67ECBD3' } },
  features: { dexSelector: false },
  gas: {
    priceDefault: new BigNumber(10).times(10 ** 9),
    amount: { coefficient: 1.2, fallback: 450000 },
  },
  lending: { assets },
  protocol: { version: 4 },
  trading: {
    defaultPair: { baseToken: Asset.ETH, quoteToken: Asset.USDT },
    pairs: tradePairs,
    baseQuote: getBaseQuote(tradePairs),
    pairConfigs: {},
  },
  native: { asset: Asset.BNB, wrapped: Asset.WBNB },
  nativeTokenSupported: true,
  compromisedContracts: [],
  icon: { name: 'binance-logo', color: '#f3ba2e' },
  chartUDF: udfFeeds.BINANCE,
  stableCoins: [Asset.USDT, Asset.BUSD],
  rpcUrlDefault: process.env.RPC_URL_BSC,
  stablecoinForUsdRates: Asset.BUSD,
  stats: { assets },
  twitterHandle: '@BinanceChain',
  uiDisabled: false,
  uiDisabledReason: '',
  wallets: [
    ProviderType.MetaMask,
    ProviderType.Binance,
    ProviderType.TrustWallet,
    ProviderType.WalletConnect,
  ],
  uniRouteSettings: {},
}

export default config
